/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 //userAgent
var ua = navigator.userAgent;

//userAgent デバイス判定
var _ua = (function(u){
  return {
    isTablet:(u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1)
      || u.indexOf("ipad") != -1
      || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
      || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
      || u.indexOf("kindle") != -1
      || u.indexOf("silk") != -1
      || u.indexOf("playbook") != -1,
    isMobile:(u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
      || u.indexOf("iphone") != -1
      || u.indexOf("ipod") != -1
      || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
      || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
      || u.indexOf("blackberry") != -1
  }
})(window.navigator.userAgent.toLowerCase());

//IE・Edge判定
var isEdge = false;
var userAgent = window.navigator.userAgent.toLowerCase();
if( userAgent.match(/(msie|MSIE)/) || userAgent.match(/(T|t)rident/) ) {
  var isIE = true;
  var ieVersion = userAgent.match(/((msie|MSIE)\s|rv:)([\d\.]+)/)[3];
  ieVersion = parseInt(ieVersion);
} else {
  var isIE = false;
  if(userAgent.indexOf("edge" )!= -1){
    isEdge = true;
  }
}

(function($){
  $(function(){

    //PCのとき tellink 無効
    if(!_ua.isMobile){
      $(".-telink").on('click', function(){
        return false;
      });
    }
    //アコーディオン
	  $(".ac-head").on('click',function(){
	    var $target = $(this);
	    $target.parents('.swiper-wrapper').addClass('-ac');
	    $target.toggleClass('-open').next('.ac-body').slideToggle(400);
	  });

    var shopSlide = new Swiper('.custom-flowcontent.swiper-container',{
      effect: 'fade',
      loop: false,
      autoplay: false,
      slidesPerView: '1',
      speed: 200,
      paginationClickable: true,
      simulateTouch: false,
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: ".page-pointers",
        type: 'bullets',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + '</span>';
        }
      },
    });

    //スムーススクロール
    if(location.href.indexOf("file")==0){
      var url = "file://" + location.hostname + location.pathname + location.search;
    }else if(location.href.indexOf("https")==0){
      var url = "https://" + location.hostname + location.pathname + location.search;
    }else{
      var url = "http://" + location.hostname + location.pathname + location.search;
    }
    $("a[href*='#'],area[href*='#']").on('click', function() {
      var id = this.href.substring(this.href.indexOf('#'),this.href.length);
      var hrefUrl = this.href.split(id);
      if(String(hrefUrl[0]) == String(url)) {
        var hash = this.hash;
        if(!hash || hash == "#") {
          return false;
        }else if(id == '#inbox') {
          $('html, body').animate({scrollTop: 0}, 500, "swing");
          return false;
        }else if(id != "#"){
          $('html, body').animate({scrollTop: $(hash).offset().top - $(".shopify-section.header-section").height()}, 500, "swing");
          return false;
        }
      }
    });
    // var mt = $(".shopify-section .main-visual").height() + 30 + "px";
    // $(".main-content").css({"background-position":`center,${mt}`});
    setTimeout (function(){
      $('.globo-form-control').last().addClass('-last');
    },800);

    //ヘッダー＋メインビジュアル分背景を下げる
    if($(window).width() > 600){
      $('.fixed-cover').addClass('-fixed');
      var tHh = $('#SiteHeader').height();
      var vis = $('.main-visual').height();
      var topH = tHh + vis + 60;
      $('body').css('background-position',`right ${topH}px,left ${topH}px`);
    }else{
      var tHh = $('#SiteHeader').height();
      var vis = $('.main-visual').height();
      var btnh = $('.fixed-cover').height() / 4 * 3;
      var topH = tHh + vis;
      var topHval = tHh + vis + btnh;
      if($('body').hasClass('template-index')){
        $('body').css('background-position',`left ${topHval}px`);
      }else{
        $('body').css('background-position',`left ${topH}px`);
      }
    }

    //スマホ時のボタン出力
    $(window).on('load scroll resize',function(){
      // if($(window).width() <= 820){
      //   var tHh = $('.site-header__element--top').height();
      //   var vis = $('.main-visual').height();
      //   var btnh = $('.fixbtn-list').height();
      //   var scrollhead = tHh + vis + btnh;
      //   var nobtn = tHh + vis;
      //   if(!$('body').hasClass('template-index')&&$(window).scrollTop() > nobtn){
      //     $('.fixed-cover').show();
      //     $('.fixed-cover').addClass('-fixed');
      //   }else if(!$('body').hasClass('template-index')&&$(window).scrollTop() <= nobtn){
      //     $('.fixed-cover').hide();
      //     $('.fixed-cover.-fixed').removeClass('-fixed');
      //   }else{
      //     $('.fixed-cover').show();
      //     if($(window).scrollTop() > scrollhead){
      //       $('.fixed-cover').addClass('-fixed');
      //     }else if($(window).scrollTop() <= scrollhead){
      //       $('.fixed-cover.-fixed').removeClass('-fixed');
      //     }
      //   }
      // }else{
        $('.fixed-cover').addClass('-fixed');
        $('.fixed-cover').show();
      // }
    });
    $(function() {
      function toggleFixedCover() {
        var winW = $(window).width();
        var $fixed = $('.fixed-cover');
        var $footer = $('.site-footer');

        if (winW <= 820) {
          var winH = $(window).height();
          var scrollTop = $(window).scrollTop();
          var footerTop = $footer.offset().top;

          // footerが見え始めたら非表示
          if (scrollTop + winH > footerTop) {
            $fixed.css('opacity', '0').css('pointer-events', 'none');
          } else {
            $fixed.css('opacity', '1').css('pointer-events', 'auto');
          }
        } else {
          // PCサイズでは常に表示
          $('.fixed-cover').css('opacity', '1').css('pointer-events', 'auto');
        }
      }

      // 初期実行とイベント登録
      toggleFixedCover();
      $(window).on('scroll resize', toggleFixedCover);
    });

    setTimeout (function(){
      if(!$('.template-page .main-content .shopify-section .rte').children().hasClass('globo-formbuilder')){
        $('.onlyoldsafari').css('display','block');
        $('.template-page .main-content .shopify-section .rte').hide();
      }else{
      }
    },800);
  });

  $(window).on('scroll',function(){
    if($(window).width() <= 820){
    if($(window).scrollTop() > $(document).height() - ($(window).height() + $('footer').height())){
      $('.fixed-cover').addClass('-hide');
    }else if($(window).scrollTop() <= $(document).height() - ($(window).height() + $('footer').height())){
      $('.fixed-cover').removeClass('-hide');
    }
    }else{}
  });

})(jQuery);
